<template>
    <div class="return-view">
        <div class="wrapper">
            <div class="return-item m-return-gift body-item">
                <div class="return-title t-1"></div>
                <div class="component-view">
                    <return-gift-view :ua="ua" :login="login"></return-gift-view>
                </div>
            </div>
            <div class="return-item m-return-task body-item">
                <div class="return-title t-2"></div>
                <div class="component-view">
                    <task-return-view :ua="ua" :login="login"></task-return-view>
                </div>
            </div>
            <div class="return-item m-lottery body-item">
                <div class="return-title t-3"></div>
                <div class="component-view">
                    <lottery-view :ua="ua" :login="login"></lottery-view>
                </div>
            </div>
            <div class="return-item m-newversion body-item">
                <div class="return-title t-4"></div>
                <div class="component-view">
                    <update></update>
                </div>
            </div>
        </div>

        <div class="side-bar return-bar" :class="['go', { 'isFixed': headerFixed }]">
            <div class="module u-btn now"></div>
            <ul>
                <li class="nav-1" :class="{'act' : active==0}" @click="scrollTo(0)"></li>
                <li class="nav-2" :class="{'act' : active==1}" @click="scrollTo(1)"></li>
                <li class="nav-3" :class="{'act' : active==2}" @click="scrollTo(2)"></li>
                <li class="nav-4" :class="{'act' : active==3}" @click="scrollTo(3)"></li>
            </ul>
            <div class="module u-btn other" @click="toTop"></div>
        </div>        
    </div>
</template>


<style>
    .return-view{
        position: relative;
        width: 100%;
        min-height: 3910px;
        background-image: url(../images/body-2.jpg);
        background-position: top center;
    }

    .isFixed{
        position: fixed;
        top: 10px;
    }

    .return-view .wrapper{
        width: 1002px;
        margin: 0 auto;
    }

    .return-title{
        margin: 0 auto 16px;
    }

    .return-title.t-1{
        width: 895px;
        height: 219px;
        background-image: url(../images/title-return-1.png);
    }

    .return-title.t-2{
        width: 895px;
        height: 219px;
        background-image: url(../images/title-return-2.png);
    }
    
    .return-title.t-3{
        width: 895px;
        height: 219px;
        background-image: url(../images/title-invite-3.png);
    }

    .return-title.t-4{
        width: 895px;
        height: 219px;
        background-image: url(../images/title-invite-4.png);
    }
    
    .m-return-gift{
        height: 1045px;
    }

    .m-return-task{
        height: 870px;
    }    

    .m-lottery{
        height: 1140px;
    }
</style>

<script>
import return_gift_view from '@/components/return.gift.vue';
import task_return_view from '@/components/task.return.vue';
import lottery_view from '@/components/lotteryView.pc.vue';
import update from '@/components/update.vue';

export default {
    data () {
        return {
          active : 0,
          headerFixed : false,
          item_top_data : [],
        }
    },
    props : {
        ua : {
            default : {},
        },
        login : {
            default : 0,
        },          
    },    
    components: {
    'return-gift-view' : return_gift_view,
    'task-return-view' : task_return_view,
    'lottery-view' : lottery_view,
    'update' : update,  
    },
    mounted (){
        this.collect_top_data();
        this.$nextTick(function () {
            window.addEventListener('scroll', this.handleScroll)
        })        
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    },    
    methods : {
        toTop (){
            var self = this;
            document.body.scrollTop = 920;
            document.documentElement.scrollTop = 920;
            setTimeout(()=>{
                self.$router.push('/invite');
            },100)
        },
        handleScroll () {
            var self = this;
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop//获取滚动距离
            this.scrollTop = scrollTop//data里return了一个全局的scrollTop

            this.headerFixed = scrollTop > 920

            var result = collectActiveNav();
            this.active = result[0];

            function collectActiveNav(){
                var ret = [] ;

                let body_item = document.querySelectorAll('.body-item');

                for (var i = 0; i < body_item.length; i++) {
                    let ele = body_item[i];
                    if (inViewport(i,0,ele)){
                        ret.push(i);
                    }                    
                } 
                return ret;
            };

            function inViewport(i, delta,ele){
                var top = self.item_top_data[i],
                    scrollTop = self.scrollTop;
                
                delta = delta || 100;
                
                //return top + delta > scrollTop && top - delta < scrollTop + document.documentElement.clientHeight;
                return top - delta + ele.offsetHeight > scrollTop && top - delta < scrollTop + document.documentElement.clientHeight;
            };	         
        },
        collect_top_data (){
            let body_item = document.querySelectorAll('.body-item');

            for (var i = 0; i < body_item.length; i++) {
                this.item_top_data.push(body_item[i].offsetTop + 850);
            }
            
        },
        scrollTo(index){
            // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉
            const STEP = 50
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop//获取滚动距离
            var targetOffsetTop = this.item_top_data[index];

            if (scrollTop < targetOffsetTop) {
                // 往下滑
                smoothDown()
            }else{
                smoothUp()
            }
            // 定义下滑函数
            function smoothDown() {
                // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
                if (scrollTop < targetOffsetTop) {
                    if (targetOffsetTop - scrollTop >= STEP) {
                        scrollTop += STEP
                    } else {
                        scrollTop = targetOffsetTop
                    }
                    document.body.scrollTop = scrollTop
                    document.documentElement.scrollTop = scrollTop
                    // 屏幕在绘制下一帧时会回调传给 requestAnimationFrame 的函数
                    requestAnimationFrame(smoothDown)
                }
            }
            // 定义上滑函数
            function smoothUp() {
                // 如果当前 scrollTop 大于 targetOffsetTop 说明视口已经滑过指定位置需要上滑
                if (scrollTop > targetOffsetTop) {
                    if (scrollTop - targetOffsetTop >= STEP) {
                        scrollTop -= STEP
                    } else {
                        scrollTop = targetOffsetTop
                    }
                    document.body.scrollTop = scrollTop
                    document.documentElement.scrollTop = scrollTop
                    requestAnimationFrame(smoothUp)
                }
            }
        },          
    }           
}
</script>


// WEBPACK FOOTER //
// src/page/return.vue